<template>
    <UserTabs
        :selected-user="selectedUser"
        :personal-team="userPersonalTeam"
        tab-key="user-teams-domains"
    >
        <div>
            <h3
                class="mt-12 mb-10 text-xl font-medium leading-normal tracking-tighter text-gray-600"
            >
                {{ t("vue.user_domains") }}
            </h3>
        </div>

        <div
            class="mt-10 overflow-hidden rounded-xl border border-gray-200 bg-white"
        >
            <div class="overflow-x-auto">
                <table class="w-full">
                    <thead class="border-b border-gray-100 bg-gray-50">
                        <tr>
                            <th
                                class="px-6 py-4 text-left text-sm font-medium text-gray-600"
                            >
                                {{ t("vue.user_domains") }}
                            </th>

                            <th
                                class="px-6 py-4 text-left text-sm font-medium text-gray-600"
                            >
                                {{ t("vue.active") }}
                            </th>

                            <th
                                class="px-6 py-4 text-left text-sm font-medium text-gray-600"
                            >
                                {{ t("vue.created_at") }}
                            </th>

                            <th
                                class="px-6 py-4 text-left text-sm font-medium text-gray-600"
                            >
                                {{ t("vue.updated_at") }}
                            </th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-gray-100">
                        <tr
                            v-for="domainRecord in userTeamsDomains"
                            :key="domainRecord"
                            class="transition-colors duration-150 hover:bg-gray-50"
                        >
                            <td class="px-6 py-4">
                                <div
                                    class="group/domain -m-2 flex items-center gap-3 rounded-lg p-2 text-left font-medium transition-colors duration-150"
                                >
                                    <div
                                        v-if="domainRecord.active === true"
                                        class="h-2 w-2 rounded-full bg-green-500"
                                    ></div>
                                    <div
                                        v-else
                                        class="h-2 w-2 rounded-full bg-gray-400"
                                    ></div>
                                    <span
                                        class="font-medium text-gray-600 transition-colors duration-150 hover:text-blue-800"
                                    >
                                        {{ domainRecord.domain }}
                                    </span>
                                </div>
                            </td>
                            <td class="px-6 py-4">
                                <span
                                    :class="[
                                        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
                                        domainRecord.active
                                            ? 'bg-green-100 text-green-800'
                                            : 'bg-gray-100 text-gray-800',
                                    ]"
                                >
                                    {{
                                        domainRecord.active
                                            ? "Active"
                                            : "Inactive"
                                    }}
                                </span>
                            </td>
                            <td class="px-6 py-4">
                                <span
                                    class="font-medium text-black-600 transition-colors duration-150 hover:text-blue-800"
                                >
                                    {{ domainRecord.created_at }}
                                </span>
                            </td>
                            <td class="px-6 py-4">
                                <span
                                    class="font-medium text-black-600 transition-colors duration-150 hover:text-blue-800"
                                >
                                    {{ domainRecord.updated_at }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </UserTabs>
</template>

<script lang="ts" setup>
import type IPaginationData from "@/components/Atomic/DataTable/types/IPaginationData";
import type ICurrentTeam from "@/types/Members/ICurrentTeam.ts";
import { useTranslations } from "@/composables/useTranslations.ts";
import type IUser from "@/types/Members/IUser.ts";
import type IDomain from "@/types/TeamsDomains/IDomain.ts";

const props = defineProps<{
    userTeamsDomains: IPaginationData<IDomain>[];
    userPersonalTeam: ICurrentTeam;
    selectedUser: IUser;
}>();

const { t } = useTranslations();
</script>
